export default{
    
  "hero_subtitle": "MAHAL – B2B Food Supply Platform",
  "hero_title_1": "Connecting Restaurants",
  "hero_title_2": "with",
  "hero_desc": "Simplify procurement, manage orders efficiently, and build long-term partnerships — all in one platform.",
  "get_started": "Get Started with MAHAL",

  "word1": "Trusted Suppliers",
  "word2": "Fresh Ingredients",
  "word3": "Competitive Prices",
  "word4": "Reliable Delivery",
}